import React, { useState, useEffect } from 'react';

import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  TextField,
} from '@material-ui/core';
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiArchiveOutline,
  mdiKeyOutline,
  mdiMagnify,
  mdiTrashCan,
  mdiWarehouse,
} from '@mdi/js';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ProductFilters } from '../interfaces';
import { Partner, Partners } from '../../partners/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Seller } from '../../createProduct/interfaces';
import { ProviderList } from '../../providers/interfaces';
import handleError from '../../../utils/handleError';
import partnersRepository from 'client-sdk/src/Repository/partners-repository';
import providersRepository from 'client-sdk/src/Repository/providers-repository';
import sellersRepository from 'client-sdk/src/Repository/sellers-repository';
import handleNotfication from '../../../utils/handleNotification';
import { setConstantValue } from 'typescript';

// styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    inputHolder: {
      flex: 1,
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
  })
);

type Props = {
  submitFilters: (values: ProductFilters) => void;
  partnersList: Partner[];
  sellersList: Seller[];
  providersList: ProviderList[];
  clearForm: () => void;
  getPartnersDispatch: (payload: any) => void;
  getProvidersDispatch: (payload: any) => void;
  getSellersDispatch: (payload: any) => void;
};

const ProductFilter = ({ submitFilters, clearForm }: Props) => {
  const classes = useStyles();
  const [provider, setProvider] = useState('');
  const [seller, setSeller] = useState('');
  const [partnersList, setPartnersList] = useState([]);
  const [providersList, setProvidersList] = useState([]);
  const [providersLoading, setProvidersLoading] = useState(false as boolean);
  const [sellersList, setSellersList] = useState([]);
  const [sellersLoading, setSellersLoading] = useState(false as boolean);
  const [partnersLoading, setPartnersLoading] = useState<boolean>(false);
  const [partners, setPartners] = useState<any>([]);
  const [partner, setPartner] = useState([]);


  const { handleSubmit, control, reset, watch, getValues, setValue } =
    useForm<ProductFilters>({
      defaultValues: {
        'partnerName.equals': '',
        'productName.contains': '',
        'productCode.equals': '',
        'productId.equals': '',
        'variantCode.equals': '',
        'id.equals': '',
        'sellerName.equals': '',
        'sellerCode.equals': '',
        'wastage.specified': false,
        'providerName.equals': '',
        'providerCode.equals': '',
        'serialNumber.equals': '',
      },
    });

  const submitForm = (values: ProductFilters) => {
    submitFilters(values);
    // console.log(partner.name);
    console.log(values);
  };

  const handleResetForm = () => {
    reset({
      'partnerName.equals': '',
      'productName.contains': '',
      'productCode.equals': '',
      'productId.equals': '',
      'variantCode.equals': '',
      'id.equals': '',
      'sellerName.equals': '',
      'wastage.specified': false,
      'sellerCode.equals': '',
      'providerName.equals': '',
      'providerCode.equals': '',
      'serialNumber.equals': '',
    });
    setProvider('');
    setSeller('');
    clearForm();
  };
  const getPartners = async (actions: any) => {
    const payload = { ...actions };
    try {
      setPartnersLoading(true);
      const { response, count } = await partnersRepository.getPartners({ payload });
      setPartners([
        ...response.data.map((partner: any) => {
          return {
            id: partner.id,
            name: partner.name,

          };
        }),
      ]);
    } catch (error) {
      handleNotfication(error.message, 'error');
    } finally {
      setPartnersLoading(false);
    }
  };

  useEffect(() => {
    getPartners({ size: 1000 });
  }, []);

  const getProviders = async (actions: any) => {
    const payload = { ...actions };
    setProvidersLoading(true);
    try {
      const { response, count } = await providersRepository.getProviders({
        payload,
      });
      setProvidersList(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setProvidersLoading(false);
    }
  };
  const getSellers = async (actions: any) => {
    const payload = { ...actions };
    setSellersLoading(true);
    try {
      const { response, count } = await sellersRepository.getSellers({ payload });
      setSellersList(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setSellersLoading(false);
    }
  };
  useEffect(() => {
    if (watch('partnerName.equals')) {
      // const partner = partnersList.find(
      //   el => el.name === getValues('partnerName.equals')
      // )!;

      getSellers({ 'partnerId.equals': partner.id, size: 10000 });
      getProviders({ 'partnerId.equals': partner.id, size: 10000 });
    }
  }, [watch('partnerName.equals')]);

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <Grid container spacing={4}>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiWarehouse} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              {/* <Controller
                style={{ width: '100%', marginBottom: '8px' }}
                name="partnerName.equals"
                control={control}
                label="نام شرکت"
                as={
                  <TextField select fullWidth>
                    {partnersList?.map((el: Partner, i) => (
                      <MenuItem key={i} value={el.name}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              /> */}
              {/* <FormControl style={{ width: '100%' }}> */}
              <Controller
                style={{ width: '100%' }}
                name="partnerName.equals"
                control={control}
                // rules={{ required: true }}
                render={({ onChange }) => (
                  <Autocomplete
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={partners}
                    // value={partner}
                    loading={partnersLoading}
                    onChange={(event: any, newValue: any) => {
                      onChange(event);
                      setPartner(newValue?.name);
                      setValue("partnerName.equals", newValue?.name);
                    }}
                    renderInput={params => (

                      <TextField

                        {...params}
                        label="نام شرکت"
                        name="partner"
                        id="partner"
                        InputProps={{
                          ...params.InputProps,
                          // type: 'search',
                          endAdornment: (
                            <React.Fragment>
                              {partnersLoading ? (
                                <CircularProgress
                                  color="inherit"
                                  size={20}
                                />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />


                    )}
                  />
                )}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiArchiveOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="productName.contains"
                label="نام کالا"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="productCode.equals"
                label="کد کالا"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="productId.equals"
                label="شناسه کالا"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="variantCode.equals"
                label="کد تنوع"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="id.equals"
                label="شناسه تنوع"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiAccountOutline} size={1} />
            </span>
            <div style={{ width: '100%' }}>
              <Controller
                style={{ width: '100%' }}
                name="sellerName.equals"
                control={control}
                render={({ onChange }) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    disabled={!watch('partnerName.equals')}
                    onChange={(_, t) => {
                      if (t) {
                        onChange(t.name);
                        setSeller(t);
                      } else {
                        onChange('');
                        setSeller('');
                      }
                    }}
                    clearOnBlur
                    getOptionSelected={(option, value) => {
                      return option.name === value.name;
                    }}
                    getOptionLabel={options => options.name}
                    options={sellersList?.length ? sellersList : []}
                    value={seller}
                    loading={sellersLoading}
                    loadingText="در حال بارگذاری"
                    renderInput={params => (
                      <TextField
                        {...params}
                        margin="normal"
                        placeholder={'نام فروشنده'}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                          endAdornment: (
                            <React.Fragment>
                              {sellersLoading &&
                                watch('partnerName.equals') ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="sellerCode.equals"
                label="کد فروشنده"
                control={control}
                as={
                  <TextField
                    disabled={!watch('partnerName.equals')}
                    type="text"
                    fullWidth
                  />
                }
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiMagnify} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                style={{ width: '100%' }}
                name="providerName.equals"
                control={control}
                render={({ onChange }) => (
                  <Autocomplete
                    noOptionsText="موردی یافت نشد"
                    disabled={!watch('partnerName.equals')}
                    onChange={(_, t) => {
                      if (t) {
                        onChange(t.name);
                        setProvider(t);
                      } else {
                        onChange('');
                        setProvider('');
                      }
                    }}
                    getOptionSelected={(option, value) => {
                      return option.name === value.name;
                    }}
                    value={provider}
                    getOptionLabel={options => options.name}
                    options={providersList?.length ? providersList : []}
                    loading={providersLoading}
                    loadingText="در حال بارگذاری"
                    renderInput={params => (
                      <TextField
                        {...params}
                        margin="normal"
                        placeholder={'نام تامین‌کننده'}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                          endAdornment: (
                            <React.Fragment>
                              {providersLoading &&
                                watch('partnerName.equals') ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="providerCode.equals"
                label="کد تامین‌کننده"
                disabled={!watch('partnerName.equals')}
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{ width: '100%' }}>
              <Controller
                name="serialNumber.equals"
                label="سریال آیتم"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiTrashCan} size={1} />
            </span>
            <span style={{ marginTop: '21px', color: 'red' }}>{'انبار ضایعات'}</span>
            <div style={{ marginTop: '21px' }}>
              <Controller
                name="wastage.specified"
                label="انبار ضایعات"
                control={control}
                as={<Checkbox />}
              />
            </div>
          </div>
        </Grid>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          style={{ marginTop: '1rem' }}
          justify="flex-end"
        >
          <Grid item xs={2} style={{ marginLeft: '1rem' }}>
            <Button
              style={{ width: '100%' }}
              variant="contained"
              color="default"
              onClick={handleResetForm}
            >
              پاک کردن فرم
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              type="submit"
              style={{ width: '100%' }}
              variant="contained"
              color="secondary"
            >
              جستجو
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

type SelectorProps = {
  providersList: ProviderList[];
  sellersList: Seller[];
  partnersList: Partners[];
};

// const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
//   partnersList: makeSelectPartnersList(),
//   providersList: makeSelectProvidersList(),
//   sellersList: makeSelectSellersList(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     getSellersDispatch: (payload: any) => dispatch(getSellersAction(payload)),
//     getProvidersDispatch: (payload: any) => dispatch(getProvidersAction(payload)),
//     getPartnersDispatch: (payload: any) => dispatch(getPartnersAction(payload)),
//   };
// }

export default ProductFilter;
